import { hotelBasketItemCardHelper } from './base'

export const HotelBasketItemCard = hotelBasketItemCardHelper.defineMultiStyleConfig({
  baseStyle: hotelBasketItemCardHelper.definePartsStyle({
    inlineText: {
      fontHeight: 'normal',
    },
  }),
})
